import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import {
  CircularProgress,
  Link,
  Breadcrumbs,
  Backdrop,
} from "@material-ui/core";
import { ArrowForward } from "@material-ui/icons";

import jQuery from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-buttons/js/buttons.flash";
import "pdfmake/build/vfs_fonts";
import "pdfmake/build/pdfmake";

import ReportTopbar from "../layouts/ReportTopbar";
import ReportLeftBar from "../layouts/ReportLeftBar";
import ReportFooter from "../layouts/ReportFooter";

import "../reports.css";
import "../datatables.min.css";

import UiDatePicker from "../../ui/uidatepicker/UiDatePicker";
import AutoComplete from "../../ui/autocomplete/AutoComplete";
import Btn from "../../ui/button/Btn";
import { API_Map } from "../../apihandler/Map";
import { API_UserLogin } from "../../apihandler/UserLogin";
import { COMMON_ACTIONS } from "../../../actions/CommonActions";
import { REPORT_ACTIONS } from "../../../actions/ReportActions";
import { dateFunction } from "../../common/datefunctions";
import {
  NOTIFY,
  ALERTS,
  FORMATS,
  REPORT_NAMES,
  REPORT_DESCRIPTION,
  DEFAULTS,
} from "../../common/consts";
import { commonJs } from "../../common/common";
import { API_Reports } from "../../apihandler/Reports";

const DefaultDismissBtn = () => {
  return <button className="snackbar-btn">{"Dismiss"}</button>;
};

var $ = jQuery;

class KmReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicles: [],
      selectedVehicle: [],
      fdt: dateFunction.getDate("thismonth", "from", FORMATS.SQL_DATE),
      tdt: dateFunction.getDate("today", "to", FORMATS.SQL_DATE),
    };
  }

  componentDidMount() {
    document.getElementById("root").classList.add("scroll");
    this.getInitialData();
  }

  getInitialData = () => {
    const args = {};
    let self = this;
    args.pageNo = 0;
    args.pageLength = 100000;
    args.orderBy = "ASC";
    args.sortColumn = "";
    API_UserLogin.setToken(localStorage.token);
    API_Map.getAllVehicles(args)
      .then((res) => {
        self.props.setVehicles({
          vehicles: res,
        });
        self.props.setLoading({
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onChangeVehicle = (vehicle) => {
    this.setState({
      selectedVehicle: vehicle,
    });
  };

  loadReport = () => {
    const { selectedVehicle, fdt, tdt } = this.state;
    let self = this;

    let imeis = [];
    for (var i = 0; i < selectedVehicle.length; i++) {
      if (selectedVehicle[i].id === "") {
        const { vehiclesList } = this.props.commonReducer;
        for (var v = 0; v < vehiclesList.length; v++) {
          imeis.push(vehiclesList[v].imei);
        }
      } else {
        imeis.push(selectedVehicle[i].id);
      }
    }

    var uniqueImeis = commonJs.getUniqueArray(imeis);

    if (imeis.length === 0) {
      commonJs.showNotify(
        self.props,
        NOTIFY.WARNING,
        ALERTS.PLEASE_SELECT_VEHICLE,
        <DefaultDismissBtn />
      );
      return;
    }

    this.props.setLoading({
      loading: true,
    });

    let args = {
      pageNo: 1,
      pageLength: DEFAULTS.DEFAULT_PAGE_LENGTH,
      fromDate: fdt,
      toDate: tdt,
      imeis: uniqueImeis,
    };

    API_Reports.getKmGraphReport(args)
      .then((res) => {
        self.props.setLoading({
          loading: false,
        });
        if (res.Result === 200) {
          let { rows, cols } = res.Response;
          let columns = [];
          for (var c = 0; c < cols.length; c++) {
            columns.push({ title: cols[c] });
          }

          if ($.fn.dataTable.isDataTable("#reportGrid")) {
            let table = $("#reportGrid").DataTable();
            table.destroy();
          }
          $("#reportGrid").empty();

          let title =
            "KM Report - " +
            dateFunction.getFormatedDate(fdt, FORMATS.DATE_ONLY) +
            " - " +
            dateFunction.getFormatedDate(tdt, FORMATS.DATE_ONLY);

          $("#reportGrid").dataTable({
            dom: "Bfrtip",
            buttons: [
              {
                extend: "copy",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "pdf",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "excel",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "csv",
                className: "reportBtn",
                title: title,
                text: "CSV",
              },
              {
                extend: "print",
                className: "reportBtn",
                title: title,
                customize: function(win) {
                  $(win.document.body)
                    .find("h1")
                    .remove();
                  $(win.document.body)
                    .find("table")
                    .attr("cellpadding", "3");
                  $(win.document.body)
                    .find("table")
                    .css("font-size", "10px");
                  $(win.document.body)
                    .find("table")
                    .css(
                      "cssText",
                      "border-bottom: none;border-left: none;border-right: none;"
                    );
                  $(win.document.body)
                    .find("td")
                    .css("font-size", "8px");
                  $(win.document.body)
                    .find("th")
                    .css("font-size", "8px");
                  $(win.document.body)
                    .find("tbody td")
                    .css(
                      "cssText",
                      "border: 1px solid #000;border-top: 0;border-right: 0;"
                    );
                  $(win.document.body)
                    .find("tbody td:last-child")
                    .css("cssText", "border: 1px solid #000;border-top: 0;");
                  $(win.document.body)
                    .find("table th")
                    .css("cssText", "border: 1px solid #000;border-right: 0;");
                  $(win.document.body)
                    .find("table th:last-child")
                    .css("cssText", "border: 1px solid #000;");
                },
              },
            ],
            paging: true,
            pageLength: 10,
            // scrollY: 400,
            columns: columns,
            data: rows,
          });
        }
      })
      .catch((err) => {
        console.log("getDailyTravel: err:", err);
      });
  };

  handleDateChange = (type, dt) => {
    if (type === "from") {
      this.setState({
        fdt: dt,
      });
    } else {
      this.setState({
        tdt: dt,
      });
    }
  };

  render() {
    const { vehiclesList } = this.props.commonReducer;

    const { loading } = this.props.reportReducer;

    const { selectedVehicle, fdt, tdt } = this.state;

    let vehicles = [];
    vehicles.push({ id: "", name: "All Vehicles" });
    for (var i = 0; i < vehiclesList.length; i++) {
      vehicles.push({ id: vehiclesList[i].imei, name: vehiclesList[i].name });
    }

    return (
      <div className="reports">
        <ReportTopbar />
        <ReportLeftBar />
        <div className="reportPageWrapper height100">
          <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
            <Link color="inherit" href="/">
              Home
            </Link>
            <p>{REPORT_NAMES.KM_REPORT}</p>
          </Breadcrumbs>
          <p className="reportDescription">{REPORT_DESCRIPTION.KM_REPORT}</p>
          <div className="reportFilters">
            <div
              className="width50"
              style={{ marginTop: 10, marginBottom: 10 }}
            >
              <AutoComplete
                label={"Select Vehicles"}
                list={vehicles}
                id="trackVehicles"
                onChange={this.onChangeVehicle}
                defaultValue={selectedVehicle}
                multiple={true}
                size="small"
              />
            </div>
            <div className="width30 uidatepicker">
              <UiDatePicker
                label="From Date :"
                dt={fdt}
                type="from"
                disablePast={false}
                disableFuture={true}
                disabled={false}
                datepicker={false}
                // maxDate={dateFunction.getDate("thismonth", "to")}
                handleDateChange={this.handleDateChange}
                datepicker={true}
              />
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForward />
              </div>
              <UiDatePicker
                label="To Date :"
                dt={tdt}
                type="to"
                disablePast={false}
                disableFuture={true}
                disabled={false}
                // maxDate={dateFunction.getDate("thismonth", "to")}
                handleDateChange={this.handleDateChange}
                datepicker={true}
              />
            </div>
            <div className="width10 padLeft-10">
              <Btn onClick={this.loadReport} className="primaryBtn">
                Submit
              </Btn>
            </div>
          </div>
          <div className="reportGridWrapper">
            <table
              id="reportGrid"
              className="mdl-data-table width100 paginated"
              cellSpacing="0"
              cellPadding="3"
            />
          </div>
        </div>

        <ReportFooter />

        <Backdrop className={"backdrop"} open={loading}>
          <CircularProgress className="whiteLoader" />
        </Backdrop>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    commonReducer: state.commonReducer,
    reportReducer: state.reportReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVehicles: (values) => {
      dispatch({
        type: COMMON_ACTIONS.SET_VEHICLES,
        values,
      });
    },
    setLoading: (values) => {
      dispatch({
        type: REPORT_ACTIONS.SET_LOADING,
        values,
      });
    },
    toggleReportPopup: (values) => {
      dispatch({
        type: REPORT_ACTIONS.TOGGLE_REPORT_POPUP,
        values,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(KmReport));
